import React from 'react'
import { Link } from 'react-router-dom'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'

const DidYouMeanBy = ({ location, didYouMeanByTerms, styles }) => {
  const parsedLocation = parseLocation(location)
  return (
    <p className={styles.didYouMeanText}>
      <strong>{'Did you mean: '}</strong>
      {didYouMeanByTerms.map((term, index) => {
        const nextQuery = Object.assign({}, parsedLocation, {
          term
        })
        return (
          <span key={index}>
            <Link to={makeLink(nextQuery)} className={styles.didYouMeanLink}>
              {term}
            </Link>
            {index < didYouMeanByTerms.length - 1 ? ', ' : null}
          </span>
        )
      })}?
    </p>
  )
}

export default DidYouMeanBy



// WEBPACK FOOTER //
// ./client/components/searchHeader/didYouMeanBy.js